import { render, staticRenderFns } from "./applications.vue?vue&type=template&id=b9a2e9cc&scoped=true"
import script from "./applications.vue?vue&type=script&lang=js"
export * from "./applications.vue?vue&type=script&lang=js"
import style0 from "./applications.vue?vue&type=style&index=0&id=b9a2e9cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a2e9cc",
  null
  
)

export default component.exports